import { HttpErrorResponse, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { ToastService } from './@theme/service/toast.service';
import { EventData } from './common/event/event';
import { EventBusService } from './common/event/event-bus.service';
import { Authentication } from './common/model/authentication';
import { AuthService } from './common/service/auth.service';
import { Accounts } from './common/util/accounts';
import { Objects } from './common/util/objects';
import { Strings } from './common/util/Strings';

@Injectable()
export class Interceptior implements HttpInterceptor {
	private isRefreshing = false;
	private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

	constructor(private toast: ToastService,
		private authService: AuthService,
		private router: Router,
		private eventBusService: EventBusService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
		const token: string = this.getToken(req.url);
		req = this.setTokenHeader(req, token);

		return next.handle(req).pipe(
			catchError((error: HttpErrorResponse) => {
				switch (error.status) {
					// case 400:
					// 	this.toast.showToast('danger', '오류가 발생 되었습니다.');
					// 	break;

					case 401:
						if (token) {
							return this.refreshToken(req, next);
						} else if (!(Objects.isNotNull(error, 'url') && error.url.indexOf('/api/a/auth') >= 0)) {
							this.eventBusService.emit(new EventData('logout', '인증이 만료되어 로그아웃 되었습니다.'));
						}
						break;
					case 403:
						this.eventBusService.emit(new EventData('logout', '인증이 만료되어 로그아웃 되었습니다.'));
						break;
					case 404:
						this.toast.showToast('danger', '페이지를 찾을 수 없습니다.');
						break;
				}

				return throwError(error);
			}),
		);
	}

	private getToken(url: string): string {
		if (Strings.isBlank(url)) return null;

		return url.indexOf('/refresh-token') >= 0 ? Accounts.getRefreshToken() : Accounts.getToken();
	}

	private refreshToken(request: HttpRequest<any>, next: HttpHandler) {
		if (!this.isRefreshing) {
			this.isRefreshing = true;

			if (Accounts.isLoggedIn()) {
				return this.authService.refreshToken().pipe(
					switchMap(() => {
						this.isRefreshing = false;
						const token = Accounts.getToken();
						this.refreshTokenSubject.next(token);
						return next.handle(this.setTokenHeader(request, token));
					}),
					catchError((error) => {
						this.isRefreshing = false;
						if (error.status == 401 && Objects.isNotNull(error, 'url') && error.url.indexOf('/refresh-token') >= 0) {
							this.eventBusService.emit(new EventData('logout', '인증이 만료되어 로그아웃 되었습니다.'));
						}
						return throwError(error);
					}),
				);
			}
		} else {
			return this.refreshTokenSubject.pipe(
				take(1),
				switchMap((token) => {
					if (token == null) return next.handle(request);
					else return next.handle(this.setTokenHeader(request, token));
				}),
			);
		}
	}

	private setTokenHeader(request: HttpRequest<any>, token: string) {
		if (token) {
			request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${token}`).set('X-Requested-With', 'XMLHttpRequest') });
		} else {
			// war 배포중 security 적용과 httpBasic을 사용하면 401응답시 기본 인증창이 발생되는데 해당 해더를 추가해야함
			// https://spring.io/guides/tutorials/spring-security-and-angular-js/#Adding%20Default%20HTTP%20Request%20Headers
			request = request.clone({ headers: request.headers.set('X-Requested-With', 'XMLHttpRequest') });
		}

		return request;
	}
}
